import { useRouter } from 'next/router'
import PropTypes from 'prop-types'
import { pick } from 'ramda'
import { useState } from 'react'

import { isBlank } from 'utils'

import useRouterQueryStateValue from 'hooks/useRouterQueryStateValue'

import Button from 'components/Button'
import CheckboxInput from 'components/CheckboxInput'
import ProductsFilter from 'components/ProductsFilter'

import { ApplyButton, Buttons, Filters, FiltersInner, OpenButton, Root } from './ProductsFilters.style'

const filterComponentProps = {
  size: { initialOpen: true },
  artisan: { initialOpen: true },
  price: { fixedOpen: true },
}

const ProductsFilters = ({ facets }) => {
  const router = useRouter()

  const [open, setOpen] = useState(false)

  const [instock, setInstock] = useRouterQueryStateValue('instock', {
    defaultValue: true,
    parser: (value) => value === 'true',
  })

  if (isBlank(facets)) return null

  const handleReset = () => {
    router.replace(
      {
        pathname: router.pathname,
        query: pick(['uid', 'q'], router.query),
      },
      undefined,
      { shallow: true }
    )

    setOpen(false)
  }

  return (
    <Root>
      <OpenButton>
        <Button text="Filter" width="full" variant="outlined" onClick={() => setOpen(true)} />
      </OpenButton>
      <Filters $open={open}>
        <FiltersInner>
          <CheckboxInput label="In-stock only" checked={instock} onChange={(e) => setInstock(e.target.checked)} />
          {facets.map(({ key, values }) => (
            <ProductsFilter key={key} name={key} values={values} {...filterComponentProps?.[key]} />
          ))}
        </FiltersInner>
        <Buttons>
          <Button text="Reset" width="full" variant="text" onClick={handleReset} />
          <ApplyButton>
            <Button text="Apply" width="full" onClick={() => setOpen(false)} />
          </ApplyButton>
        </Buttons>
      </Filters>
    </Root>
  )
}

ProductsFilters.propTypes = {
  facets: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      values: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    })
  ).isRequired,
}

ProductsFilters.defaultProps = {}

export default ProductsFilters
